(function () {
	const initProductAccordion = () => {
		
		// First, ensure all descriptions are hidden except those with default_open
		$(".product-about__accordion-description").hide();
		
		// Check for default_open - look at the HTML structure
		$(".product-about__accordion-title").each(function() {
			// Check if this title has the 'active' class from Liquid
			if ($(this).hasClass("active")) {
				// Show its description
				$(this)
					.siblings(".product-about__accordion-description")
					.show();
			}
		});
		
		// Handle click events
		$(".product-about__accordion-title").off("click").on("click", function(e) {
			e.preventDefault();
			
			// Toggle active class on clicked title
			$(this).toggleClass("active");
			
			// Toggle the description of clicked accordion only
			$(this)
				.siblings(".product-about__accordion-description")
				.stop()
				.slideToggle(300);
		});
	};

	// Initialize on page load
	$(document).ready(function() {
		initProductAccordion();
	});

	// Re-initialize when section is loaded via Shopify AJAX
	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

})();